const Responsive_Coding_Assignment_3 = () => {
  return (
    <div>
      <h1>Responsive Coding Assignment 3</h1>
    </div>
  );
};
export default Responsive_Coding_Assignment_3;
